import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    withdrawalFee: 'Withdrawal fee',
    securityFeeTooltip:
      'Lombard prioritizes security and does not profit from these fees.',
    withdrawalFeeValue: '0.01%',
    withdrawalTime: 'Withdrawal time',
    withdrawalTimeValue: '3 days',
    withdrawalInProgress: 'Withdrawal in progress. Time left: {time} {unit}',
  },
};
